import { render, staticRenderFns } from "./DadosProcessadosRosca.vue?vue&type=template&id=79d5631b&scoped=true&"
import script from "./DadosProcessadosRosca.vue?vue&type=script&lang=js&"
export * from "./DadosProcessadosRosca.vue?vue&type=script&lang=js&"
import style0 from "./DadosProcessadosRosca.vue?vue&type=style&index=0&id=79d5631b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d5631b",
  null
  
)

export default component.exports